import { render } from "./AgentLastCalls.vue?vue&type=template&id=8b3dfc0c&scoped=true"
import script from "./AgentLastCalls.vue?vue&type=script&lang=js"
export * from "./AgentLastCalls.vue?vue&type=script&lang=js"

import "./AgentLastCalls.vue?vue&type=style&index=0&id=8b3dfc0c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3dfc0c"]])

export default __exports__